var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$userIsAdmin)?_c('programs-single-graduates-admin'):_vm._e(),(_vm.$userIsCoordinator)?_c('programs-single-graduates-coordinator'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }